<template>
  <div data-v-abca6e38="" data-v-2ac6a5fc="" class="assets-wrap">
    <div data-v-abca6e38="" class="assets">
      <!-- 1. 顶部Banner -->
      <div data-v-abca6e38="" class="banner">
        <div class="balance-header">
          <p data-v-abca6e38="" class="balance-label">总金额(CNY)</p>
          <div class="balance-value-wrap">
            <h1 data-v-abca6e38="" class="balance-value">{{ $store.state.userInfo.balance || '0.00' }}</h1>
          </div>
        </div>
        <!-- 顶部按钮组：固定宽度+居中 -->
        <div class="banner-btns fixed-btn-group">
          <h2 class="transfer-all-btn" @click="transall">一键回收</h2>
          <div class="transfer-mode-btn" @click="changeTasfer">
            <span class="mode-text">{{ $store.state.userInfo.transferstatus == 0 ? '转账模式' : '免转模式' }}</span>
          </div>
        </div>
		<div data-v-abca6e38="" v-if="shws" @click="openList" class="collapse-btn"></div>		
        <div data-v-abca6e38="" class="banner-arrow" @click="openList">
          <span data-v-abca6e38="" class="arrow-down" :class="{ 'arrow-up': shws }"></span>
        </div>
      </div>
      <!-- 2. 游戏余额下拉列表（强制3列） -->
      <div data-v-abca6e38="" class="list-wrap card-style" v-show="shws">
        <div data-v-abca6e38="" class="game-list-container">
          <!-- 3列游戏卡片 -->
          <div data-v-abca6e38="" class="game-card" v-for="(item, index) in balancelist" :key="index">
            <p data-v-abca6e38="" class="game-name">{{ item.name }}</p>
            <div class="game-balance-wrap">
              <p data-v-abca6e38="" class="game-balance">{{ item.balance || '0.00' }}</p>
            </div>
            <p class="transfer-btn-container">
              <span class="btne" v-if="$store.state.userInfo.transferstatus == 0" @click="oneUpdate(item)">额度转换</span>
            </p>
          </div>
          <div v-if="balancelist.length === 0" class="game-list-empty">
            <p>暂无游戏数据</p>
          </div>
        </div>
      </div>
      <!-- 3. 记录区域（修复滚动问题：新增独立滚动容器） -->
      <div data-v-abca6e38="" class="content">
        <!-- 外层容器：统一宽度控制 -->
        <div data-v-abca6e38="" class="record-main-container card-style">
          <!-- 记录标题 -->
          <div data-v-abca6e38="" class="record-title">
            <span>记录类型</span>
          </div>
          <!-- 分类按钮 -->
          <div data-v-abca6e38="" class="tab-container card-style">
            <div class="tab-scroll">
              <a data-v-abca6e38="" @click="changType(0)" :class="type == 0 ? 'active' : ''">存款</a>
              <a data-v-abca6e38="" @click="changType(1)" :class="type == 1 ? 'active' : ''">取款</a>
              <a data-v-abca6e38="" @click="changType(2)" :class="type == 2 ? 'active' : ''">转入</a>
              <a data-v-abca6e38="" @click="changType(3)" :class="type == 3 ? 'active' : ''">转出</a>
              <a data-v-abca6e38="" @click="changType(4)" :class="type == 4 ? 'active' : ''">投注</a>
              <a data-v-abca6e38="" @click="changType(5)" :class="type == 5 ? 'active' : ''">返水</a>
            </div>
          </div>
          <!-- 筛选区域 -->
          <div class="filter-card card-style">
            <div class="filter-grid">
              <div class="filter-item">
                <el-select 
                  size="mini" 
                  v-model="api_type" 
                  placeholder="请选择平台" 
                  @change="changApiType"
                  style="width: 100%;"
                >
                  <el-option v-for="(item, index) in dogameLis" :key="index" :label="item.name" :value="item.platname"> </el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <el-radio-group 
                  v-model="date" 
                  size="mini" 
                  fill="#fecb4d" 
                  @change="changApiType"
                  style="width: 100%;text-align: center;"
                >
                  <el-radio-button label="1">今日</el-radio-button>
                  <el-radio-button label="2">7日内</el-radio-button>
                  <el-radio-button label="3">半月内</el-radio-button>
                  <el-radio-button label="4">一月内</el-radio-button>
                </el-radio-group>
              </div>
            </div>
          </div>
          <!-- 返水领取提示 -->
          <div v-if="type == 5" class="rebate-tip card-style" @click="lingqu">
            <span>累计领取 {{ jisuan || 0 }} 待领取{{ nojisuan || 0 }}</span>
            <span class="get-btn">点击领取</span>
          </div>
          <!-- 核心修复：新增独立滚动容器，确保数据少也能滚动 -->
          <div class="record-scroll-container">
            <!-- 记录列表（统一渲染逻辑） -->
            <div class="record-list">
              <!-- 存款/取款/转入/转出/返水记录 -->
              <div data-v-73a82902="" class="record-item card-style" v-for="(item, index) in getRecordList" :key="index">
                <div data-v-73a82902="" class="item left">
                  <p data-v-73a82902="" class="txt-bold">
                    {{ getAmountLabel }}：<span class="record-amount">{{ getAmountValue(item) || 0 }}</span>
                    <span data-v-73a82902=" " class="time">{{ item.created_at || item.bet_time || '-' }}</span>
                  </p>
                  <p data-v-73a82902="" class="payType">
                    {{ item.pay_way || item.Code || item.gamename || '无' }}
                    <span data-v-73a82902=" " class="win-loss" v-if="type == 4">派彩：<span class="record-amount">{{ item.win_loss || 0 }}</span></span>
                  </p>
                  <p data-v-73a82902="" class="order-no" v-if="showOrderNo">
                    订单号：{{ item.out_trade_no || item.bet_id || '-' }}
                  </p>
                </div>
                <div data-v-73a82902="" class="item right">
                  <p data-v-73a82902="" class="status">{{ getStatusText(item) || '未知' }}</p>
                </div>
              </div>
              <!-- 空状态 -->
              <div data-v-abca6e38="" class="empty card-style" v-if="getRecordList.length == 0">
                <div data-v-abca6e38="" class="icon-empty"></div>
                <p data-v-abca6e38="">暂无记录</p>
              </div>
            </div>
          </div>
          <!-- 分页控件：修复显示逻辑，确保数据少也正常展示 -->
          <div class="pagination-container" v-if="last_page > 1 || getRecordList.length > 0">
            <div class="pagination">
              <button 
                class="page-btn" 
                @click="changePage(1)" 
                :disabled="page === 1"
              >
                首页
              </button>
              <button 
                class="page-btn" 
                @click="changePage(page - 1)" 
                :disabled="page === 1"
              >
                上一页
              </button>
              <span class="page-info">
                第 {{ page }} 页 / 共 {{ last_page || 1 }} 页
              </span>
              <button 
                class="page-btn" 
                @click="changePage(page + 1)" 
                :disabled="page === (last_page || 1)"
              >
                下一页
              </button>
              <button 
                class="page-btn" 
                @click="changePage(last_page || 1)" 
                :disabled="page === (last_page || 1)"
              >
                末页
              </button>
              <div class="page-jump">
                <span>跳至</span>
                <input 
                  type="number" 
                  v-model.number="jumpPage" 
                  min="1" 
                  :max="last_page || 1"
                  @keyup.enter="handleJump"
                >
                <span>页</span>
                <button @click="handleJump" class="jump-btn">确定</button>
              </div>
            </div>
            <div class="page-size-info">
              每页显示 10 条记录
            </div>
          </div>
        </div>
      </div>
      <!-- 额度转换弹窗 -->
      <div data-v-710c460e="" data-v-0dc57850="" class="popup-background" @touchmove.prevent v-if="show">
        <div data-v-0dc57850="" data-v-710c460e="" class="safety-popup">
          <div data-v-0dc57850="" data-v-710c460e="" class="popup card-style">
            <div data-v-0dc57850="" data-v-710c460e="" class="pop-head">额度转换 
              <a data-v-0dc57850="" data-v-710c460e="" @click="hideShow" class="pop-close"></a>
            </div>
            <div data-v-0dc57850="" data-v-710c460e="" class="pop-content">
              <p data-v-0dc57850="" data-v-710c460e="" class="hg">
                <span class="leftSpan">转换方式</span> 
                <span :class="payType == 0 ? 'active' : ''" @click="payType=0">转入</span>
                <span :class="payType == 1 ? 'active' : ''" @click="payType=1">转出</span>
              </p>
              <p data-v-0dc57850="" data-v-710c460e="" class="hg">
                <span class="leftSpan">账户余额</span>
                <input class="popup-balance" :value="$store.state.userInfo.balance || 0" disabled />
              </p>
              <p data-v-0dc57850="" data-v-710c460e="" class="hg">
                <span class="leftSpan">游戏余额</span>
                <input class="popup-balance" :value="oneInfo.balance || 0" disabled />
              </p>
              <p data-v-0dc57850="" data-v-710c460e="" class="hg">
                <span class="leftSpan">操作金额</span>
                <input placeholder="请输入操作金额" v-model="amount" />
              </p>
              <a data-v-0dc57850="" data-v-710c460e="" @click="isOk()" class="button">确认转换</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'assets',
  data() {
    return {
      type: 0, // 0存款1取款2转入3转出4投注5返水
      list: [], // 存款/取款/转入/转出记录
      list4: [], // 投注记录
      list5: [], // 返水记录
      page: 1,
      last_page: 0,
      balancelist: [], // 游戏余额列表
      daoTime: null, // 定时刷新余额
      oneInfo: {}, // 当前选中游戏信息
      show: false, // 弹窗显示状态
      amount: null, // 转换金额
      payType: 0, // 0转入1转出
      shws: false, // 游戏列表显示状态
      date: 4, // 1今日27日3半月4一月
      dogameLis: [{ name: '全平台', platname: '' }], // 平台列表
      api_type: '', // 选中平台
      jisuan: 0, // 已领返水
      nojisuan: 0, // 待领返水
      jumpPage: 1, // 跳转页码
      // 状态映射
      stateMap: {
        12: ['未定义', '待审核', '审核通过', '审核拒绝'], // 存款/取款状态
        34: ['失败', '成功', '待结算', '未定义'], // 转入/转出状态
        4: ['无效注单', '已结算', '未结算'], // 投注状态
        5: ['待领取', '已领取'] // 返水状态
      }
    };
  },
  created() {
    this.initData();
    this.daoTime = setInterval(() => this.getbalancelist(), 3000);
  },
  computed: {
    // 统一记录列表渲染（减少v-if冗余）
    getRecordList() {
      return this.type === 4 ? this.list4 : this.type === 5 ? this.list5 : this.list;
    },
    // 金额标签（根据类型动态显示）
    getAmountLabel() {
      return this.type === 4 ? '投注金额' : this.type === 5 ? '返水金额' : '金额';
    },
    // 是否显示订单号
    showOrderNo() {
      return [0, 1, 4].includes(this.type);
    },
    // 状态映射表（根据类型动态选择）
    getStateMap() {
      if ([0, 1].includes(this.type)) return this.stateMap[12];
      if ([2, 3].includes(this.type)) return this.stateMap[34];
      if (this.type === 4) return this.stateMap[4];
      if (this.type === 5) return this.stateMap[5];
      return [];
    }
  },
  methods: {
    // 初始化数据（精简重复调用）
    initData() {
      this.page = 1;
      this.getbalancelist();
      this.getdogame();
      // 路由参数处理
      if (this.$route.query.type) this.type = this.$route.query.type * 1;
      if (this.$route.query.expandBalance === '1') {
        setTimeout(() => this.openList(), 100);
      }
      this.getRecordData();
    },
    // 统一获取记录数据（合并6个getList方法）
    getRecordData() {
      this.$parent.showLoading();
      // 添加每页显示10条的参数
      const params = { 
        api_type: this.api_type, 
        date: this.date, 
        page: this.page,
        page_size: 10 // 每页显示10条记录
      };
      let url = '/api/gettransrecord';
      let typeParam = this.type + 1; // 存款type=1，对应this.type=0
      // 特殊处理投注/返水接口
      if (this.type === 4) {
        url = '/api/betrecord';
        typeParam = null;
      } else if (this.type === 5) {
        url = '/api/getfanshui';
        typeParam = '';
      }

      this.$apiFun.post(url, typeParam ? { ...params, type: typeParam } : params)
        .then(res => {
          if (res.code !== 200) return this.$parent.showTost(0, res.message);
          // 修复分页数据格式兼容，使用传统方式替代可选链
          const responseData = res.data || {};
          // 替代 responseData.list?.last_page
          const listLastPage = responseData.list && responseData.list.last_page ? responseData.list.last_page : 0;
          this.last_page = responseData.last_page || listLastPage || 0;
          
          // 替代 responseData.list?.data
          const listDataValue = responseData.list && responseData.list.data ? responseData.list.data : [];
          const listData = responseData.data || listDataValue || [];
          
          // 统一处理分页和数据赋值
          if (this.page === 1) {
            this[this.type === 4 ? 'list4' : this.type === 5 ? 'list5' : 'list'] = listData;
          } else {
            this[this.type === 4 ? 'list4' : this.type === 5 ? 'list5' : 'list'] = [
              ...this[this.type === 4 ? 'list4' : this.type === 5 ? 'list5' : 'list'], 
              ...listData
            ];
          }
          // 返水特殊数据
          if (this.type === 5) {
            this.jisuan = res.data.jisuan || 0;
            this.nojisuan = res.data.nojisuan || 0;
          }
          // 更新跳转页码
          this.jumpPage = this.page;
        })
        .finally(() => this.$parent.hideLoading());
    },
    // 分页方法：改变页码（修复滚动定位）
    changePage(newPage) {
      // 验证页码有效性
      if (newPage < 1 || newPage > (this.last_page || 1)) return;
      this.page = newPage;
      // 滚动到记录区域顶部（优化体验）
      const recordContainer = document.querySelector('.record-main-container');
      if (recordContainer) {
        recordContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      this.getRecordData();
    },
    // 处理页码跳转（修复边界值）
    handleJump() {
      let targetPage = parseInt(this.jumpPage);
      // 验证输入有效性（兼容无分页场景）
      const maxPage = this.last_page || 1;
      if (isNaN(targetPage) || targetPage < 1) {
        targetPage = 1;
      } else if (targetPage > maxPage) {
        targetPage = maxPage;
      }
      this.jumpPage = targetPage;
      this.changePage(targetPage);
    },
    // 统一获取金额值（处理不同记录的金额字段差异）
    getAmountValue(item) {
      return this.type === 4 ? item.bet_amount : this.type === 5 ? item.money : item.amount;
    },
    // 统一获取状态文本（减少重复判断）
    getStatusText(item) {
      const state = item.state * 1;
      if (this.type === 5) return this.getStateMap[state] || '未知';
      return this.getStateMap[state] || '未知';
    },
    // 返水领取
    lingqu() {
      if (this.nojisuan <= 0) return this.$parent.showTost(0, '暂无领取额度！');
      this.$parent.showLoading();
      this.$apiFun.post('/api/dofanshui', {})
        .then(res => {
          this.$parent.getUserInfoss();
          this.$parent.showTost(1, res.message);
          this.page = 1;
          this.getRecordData();
        })
        .finally(() => this.$parent.hideLoading());
    },
    // 一键回收
    transall() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/transall', {})
        .then(res => {
          this.$parent.showTost(1, res.message);
          this.getbalancelist();
          this.refreshusermoney();
        })
        .finally(() => this.$parent.hideLoading());
    },
    // 刷新用户余额
    refreshusermoney() {
      this.$apiFun.post('/api/refreshusermoney', {})
        .then(res => {
          if (res.code === 200) {
            localStorage.setItem('userInfo', JSON.stringify(res.data));
            this.$store.commit('changUserInfo');
          }
        });
    },
    // 获取平台列表
    getdogame() {
      this.$apiFun.post('/api/balancelist', {})
        .then(res => {
          if (res.code === 200) this.dogameLis = [...this.dogameLis, ...res.data];
        });
    },
    // 切换平台/日期筛选（修复页码重置）
    changApiType() {
      this.page = 1;
      this.getRecordData();
    },
    // 切换转账/免转模式
    changeTasfer() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      const mianzhuan = userInfo.transferstatus ^ 1; // 0→1，1→0
      this.$parent.showLoading();
      this.$apiFun.post('/api/uptransferstatus', { transferstatus: mianzhuan })
        .then(res => {
          if (res.code === 200) {
            userInfo.transferstatus = mianzhuan;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            this.$store.commit('changUserInfo');
            this.$parent.showTost(1, '操作成功！');
          }
        })
        .finally(() => this.$parent.hideLoading());
    },
    // 确认额度转换
    isOk() {
      if (!this.amount) return this.$parent.showTost(0, '请输入操作金额！');
      const maxAmount = this.payType === 0 
        ? this.$store.state.userInfo.balance 
        : this.oneInfo.balance;
      if (this.amount * 1 > maxAmount * 1) {
        return this.$parent.showTost(0, `操作金额超出${this.payType === 0 ? '账户' : '游戏'}余额！`);
      }
      this.$parent.showLoading();
      this.$apiFun.post('/api/transfer', {
        amount: this.amount,
        sourcetype: this.payType === 0 ? 'userbalance' : this.oneInfo.platname,
        targettype: this.payType === 0 ? this.oneInfo.platname : 'userbalance'
      }).then(res => {
        this.$parent.showTost(1, res.message);
        if (res.code === 200) {
          this.hideShow();
          this.refreshusermoney();
          this.getbalancelist();
        }
      }).finally(() => this.$parent.hideLoading());
    },
    // 关闭弹窗
    hideShow() {
      this.show = false;
      this.amount = null;
    },
    // 选择游戏（打开转换弹窗）
    oneUpdate(val) {
      this.oneInfo = { ...val };
      this.show = true;
    },
    // 展开/收起游戏列表（修复箭头状态）
    openList() {
      this.shws = !this.shws;
    },
    // 切换记录类型（修复滚动和数据重置）
    changType(type) {
      if (this.type === type) return;
      this.type = type;
      this.page = 1;
      // 切换类型时滚动到记录区域
      const recordContainer = document.querySelector('.record-main-container');
      if (recordContainer) {
        recordContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      this.getRecordData();
    },
    // 获取游戏余额列表
    getbalancelist() {
      this.$apiFun.post('/api/balancelist', {})
        .then(res => {
          if (res.code === 200) this.balancelist = res.data;
          if (res.code !== 200 && this.daoTime) clearInterval(this.daoTime);
        });
    }
  },
  mounted() {
    // 初始化滚动容器高度（适配窗口）
    const initScrollHeight = () => {
      const windowHeight = window.innerHeight;
      // 修复：使用传统方式替代可选链获取banner高度
      const bannerElement = document.querySelector('.banner');
      const bannerHeight = bannerElement ? bannerElement.offsetHeight : 200;
      
      const recordContainer = document.querySelector('.record-scroll-container');
      if (recordContainer) {
        // 滚动容器高度 = 窗口高度 - Banner高度 - 筛选区高度 - 分页高度（预留200px）
        recordContainer.style.maxHeight = `${windowHeight - bannerHeight - 200}px`;
      }
    };
    // 初始化+窗口 resize 时重新计算
    initScrollHeight();
    window.addEventListener('resize', initScrollHeight);
  },
  beforeDestroy() {
    if (this.daoTime) clearInterval(this.daoTime);
    // 移除窗口监听
    window.removeEventListener('resize', () => {});
  },
};
</script>

<style lang="scss" scoped>
// 全局变量
$card-radius: 12px;
$card-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
$card-bg: #fff;
$border-color: #f0f0f0;
$primary-color: #fecb4d;
$text-main: #333;
$text-secondary: #666;
$text-light: #999;
$primary-dark: darken($primary-color, 10%);
// 1. 外层容器（修复整体滚动）
.assets-wrap {
  background: #fafafa;
  min-height: 100vh;
  padding: 16px;
  box-sizing: border-box;
  max-width: 1400px; 
  margin: 0 auto;
  overflow-x: hidden;
  overflow-y: auto; // 确保整体可滚动
}
// 2. 顶部Banner - 优化后的样式
.banner {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  border-radius: $card-radius;
  box-shadow: 0 10px 25px -5px rgba(99, 102, 241, 0.1), 0 8px 10px -6px rgba(99, 102, 241, 0.1);
  min-height: 25vh;
  padding: 24px 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  
  .balance-header {
    text-align: center;
    margin-bottom: 24px;
    
    .balance-label {
      color: rgba(255, 255, 255, 0.8);
      font-size: 16px;
      margin-bottom: 8px;
    }
    
    .balance-value-wrap {
      background: rgba(255, 255, 255, 0.15);
      border-radius: 8px;
      padding: 16px 32px;
      backdrop-filter: blur(8px);
      
      .balance-value {
        color: #fff;
        font-size: 36px;
        font-weight: 600;
        letter-spacing: 2px;
        margin: 0;
      }
    }
  }
  
  // 按钮组：固定宽度，不分散
  .banner-btns {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 32px;
    
    &.fixed-btn-group {
      width: 480px;
      justify-content: center;
      flex-wrap: nowrap;
    }
    
    .transfer-all-btn, .transfer-mode-btn {
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      padding: 8px 18px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      border-radius: 24px;
      transition: all 0.3s;
      white-space: nowrap;
      
      &:hover {
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.5);
      }
    }
    
    .collapse-btn {
      color: rgba(255, 255, 255, 0.7);
      font-size: 14px;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 24px;
      transition: all 0.3s;
      white-space: nowrap;
      
      &:hover {
        color: #fff;
        background: rgba(255, 255, 255, 0.15);
      }
    }
    
    .mode-icon {
      width: 18px;
      height: 18px;
      filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
      margin-right: 6px;
    }
  }
  
  // 下拉箭头
  .banner-arrow {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 50%;
    transition: background 0.3s;
    
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    
    .arrow-down {
      display: inline-block;
      width: 24px;
      height: 24px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
      transition: all 0.3s;
    }
    
    .arrow-up {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E");
    }
  }
}
// 3. 游戏余额列表（核心：强制3列）
.list-wrap {
  margin: 16px 0;
  overflow: hidden;
  .game-list-container {
    background: $card-bg;
    border-radius: $card-radius;
    box-shadow: $card-shadow;
    padding: 20px;
    display: grid; 
    grid-template-columns: repeat(3, 1fr); 
    gap: 10px;
    box-sizing: border-box;
    width: 100%;
    .game-card {
      background: $card-bg;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      padding: 18px 12px;
      text-align: center;
      transition: all 0.3s;
      box-sizing: border-box;
      border: 1px solid $border-color;
      min-height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;     
      min-width: 0;     
      max-width: none;  
      margin: 0;        
      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
        border-color: rgba(254, 203, 77, 0.3);
      }
      .game-name {
        color: $text-main;
        font-size: 14px;
        font-weight: 500;
        margin: 0 0 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .game-balance-wrap {
        background: #fff8e6;
        border-radius: 6px;
        padding: 8px 0;
        margin-bottom: 10px;
        .game-balance {
          color: $primary-color;
          font-size: 18px;
          font-weight: 600;
          margin: 0;
        }
      }
      .btne {
        background: linear-gradient(90deg, $primary-color, #ffd780);
        color: #482000;
        font-size: 12px;
        padding: 6px 0;
        border-radius: 6px;
        width: 90%;
        display: block;
        transition: all 0.3s;
        cursor: pointer;
        border: none;
        margin: 0 auto;
        &:hover {
          opacity: 0.95;
          transform: scale(1.03);
        }
      }
    }
    .game-list-empty {
      grid-column: 1 / -1; // 占满所有列
      width: 100%;
      text-align: center;
      padding: 40px 0;
      color: $text-light;
      font-size: 14px;
    }
  }
}
// 4. 记录区域（核心修复：独立滚动容器）
.content {
  width: 100%;
  box-sizing: border-box;
  .record-main-container {
    width: calc(100% - 2px);
    margin: 0 auto;
    padding: 20px 10px;
    box-sizing: border-box;
    overflow: visible; // 取消容器固定高度，允许内容自然溢出
  }
  // 记录标题
  .record-title {
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid $border-color;
    color: $text-main;
    font-size: 16px;
    font-weight: 500;
  }
  // 分类按钮
  .tab-container {
    margin-bottom: 16px;
    padding: 14px 16px;
    border: 1px solid $border-color;
    border-radius: $card-radius;
    .tab-scroll {
      display: flex;
      justify-content: space-between;
      gap: 8px;
      a {
        flex: 1;
        text-align: center;
        padding: 8px 0;
        border-radius: 6px;
        font-size: 14px;
        color: $text-secondary;
        transition: all 0.3s;
        &.active {
          background: linear-gradient(90deg, $primary-color, #ffd780);
          color: #482000;
          font-weight: 500;
          box-shadow: 0 2px 8px rgba(254, 203, 77, 0.2);
        }
        &:hover:not(.active) {
          background: #fff8e6;
          color: #482000;
        }
      }
    }
  }
  // 筛选区域
  .filter-card {
    margin-bottom: 16px;
    padding: 14px 16px;
    border: 1px solid $border-color;
    border-radius: $card-radius;
    .filter-grid {
      display: grid;
      gap: 16px;
      width: 100%;
    }
    .filter-item {
      width: 100%;
      box-sizing: border-box;
    }
    el-select {
      border: 1px solid $border-color !important;
      border-radius: 6px !important;
      height: 32px !important;
      .el-input__inner {
        border: none !important;
        height: 32px !important;
        line-height: 32px !important;
      }
    }
    el-radio-group {
      display: flex !important;
      justify-content: space-between !important;
      gap: 8px;
      .el-radio-button {
        flex: 1 !important;
        text-align: center !important;
        .el-radio-button__inner {
          border-color: $border-color;
          color: $text-secondary;
          border-radius: 6px !important;
          padding: 0 10px !important;
          height: 32px !important;
          line-height: 32px !important;
          &:hover {
            border-color: $primary-color;
            color: $primary-color;
          }
        }
        &.is-active .el-radio-button__inner {
          background: $primary-color;
          border-color: $primary-color;
          color: #482000;
        }
      }
    }
  }
  // 返水提示
  .rebate-tip {
    margin-bottom: 16px;
    padding: 14px 16px;
    border: 1px solid $border-color;
    border-radius: $card-radius;
    background: #fff8e6;
    color: $text-main;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    .get-btn {
      color: white;
      font-weight: 500;
      border-radius: 30px;
      padding: 5px 12px;
      background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
      border: 1px solid rgba(76, 175, 80, 0.3);
      box-shadow: 0 4px 12px rgba(76, 175, 80, 0.2);
      cursor: pointer;
      transition: all 0.3s ease;
      font-size: 12px;
      text-align: center;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }
    .get-btn:hover {
      background: linear-gradient(135deg, #55bb5a 0%, #43a047 100%);
      box-shadow: 0 6px 16px rgba(76, 175, 80, 0.3);
      transform: translateY(-2px);
    }
    
    .get-btn:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(76, 175, 80, 0.2);
    }
    
    .get-btn:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
      background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
    }
  }
  // 核心修复：独立滚动容器（数据少也能滚动）
  .record-scroll-container {
    max-height: 400px; // 固定最大高度，超出滚动
    min-height: 150px; // 数据少时保持最小高度，确保可滚动
    overflow-y: auto; // 纵向滚动
    overflow-x: hidden;
    margin-bottom: 20px;
    padding-right: 8px; // 预留滚动条空间
    // 滚动条美化
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-track {
      background: #f5f5f5;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #e0e0e0;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #d0d0d0;
    }
  }
  // 记录列表
  .record-list {
    gap: 12px;
    display: flex;
    flex-direction: column;
    .record-item {
      padding: 14px 20px;
      border: 1px solid $border-color;
      border-radius: $card-radius;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      }
      .item {
        display: flex;
        flex-direction: column;
      }
      .left {
        flex: 4;
        padding-right: 16px;
        .txt-bold {
          color: $text-main;
          font-weight: 500;
          margin-bottom: 10px;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          line-height: 22px;
          .record-amount {
            color: $primary-color;
            font-weight: 600;
            margin-right: 35px;
            font-size: 15px;
          }
          .time {
            color: $text-secondary;
            font-size: 12px;
            font-weight: normal;
            white-space: nowrap;
          }
        }
        .payType {
          color: $text-secondary;
          font-size: 13px;
          margin-bottom: 6px;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          line-height: 20px;
        }
        .order-no {
          color: $text-light;
          font-size: 12px;
          word-break: break-all;
          line-height: 18px;
        }
      }
      .right {
        flex: 1;
        padding-top: 2px;
        .status {
          padding: 6px 10px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 500;
          white-space: nowrap;
          margin-left: auto;
        }
      }
    }
    .empty {
      text-align: center;
      padding: 50px 20px;
      color: $text-light;
      font-size: 14px;
      border: 1px solid $border-color;
      border-radius: $card-radius;
      .icon-empty {
        width: 72px;
        height: 72px;
        margin: 0 auto 20px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='72' height='72' viewBox='0 0 24 24' fill='none' stroke='%23e0e0e0' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cline x1='12' y1='8' x2='12' y2='12'%3E%3C/line%3E%3Cline x1='12' y1='16' x2='12.01' y2='16'%3E%3C/line%3E%3C/svg%3E");
      }
    }
  }
  // 分页控件（修复显示逻辑）
  .pagination-container {
    margin-top: 10px;
    padding: 18px 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-top: 1px solid $border-color;
    .pagination {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;
      flex-wrap: wrap;
      justify-content: center;
      .page-btn {
        padding: 8px 16px;
        border: 1px solid $border-color;
        border-radius: 20px;
        background-color: $card-bg;
        color: $text-secondary;
        cursor: pointer;
        transition: all 0.3s ease;
        font-size: 14px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
        &:hover:not(:disabled) {
          border-color: $primary-color;
          color: #482000;
          background-color: #fff8e6;
          transform: translateY(-1px);
          box-shadow: 0 2px 5px rgba(254, 203, 77, 0.1);
        }
        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          background-color: #fafafa;
          transform: none;
          box-shadow: none;
        }
      }
      .page-info {
        color: $text-main;
        font-size: 14px;
        padding: 8px 16px;
        background-color: #f8f8f8;
        border-radius: 20px;
        margin: 0 4px;
        min-width: 120px;
        text-align: center;
      }
      .page-jump {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 14px;
        color: $text-secondary;
        margin-left: 10px;
        padding: 4px 8px;
        background-color: #f8f8f8;
        border-radius: 20px;
        input {
          width: 50px;
          height: 32px;
          padding: 0 8px;
          border: 1px solid $border-color;
          border-radius: 4px;
          text-align: center;
          transition: all 0.2s;
          &:focus {
            outline: none;
            border-color: $primary-color;
            box-shadow: 0 0 0 2px rgba(254, 203, 77, 0.2);
          }
        }
        .jump-btn {
          padding: 6px 14px;
          background-color: $primary-color;
          color: #482000;
          border: none;
          border-radius: 16px;
          cursor: pointer;
          transition: all 0.3s ease;
          font-weight: 500;
          &:hover {
            background-color: $primary-dark;
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(254, 203, 77, 0.3);
          }
          &:active {
            transform: translateY(0);
          }
        }
      }
    }
    .page-size-info {
      color: $text-light;
      font-size: 12px;
      margin-top: 5px;
      padding: 4px 12px;
      border-radius: 12px;
      background-color: #f8f8f8;
    }
  }
}
// 弹窗样式
.popup-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  .safety-popup {
    width: 90%;
    max-width: 420px;
    .popup {
      background: $card-bg;
      border-radius: $card-radius;
      box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
      overflow: hidden;
      .pop-head {
        padding: 16px 20px;
        border-bottom: 1px solid $border-color;
        color: $text-main;
        font-size: 16px;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .pop-close {
          width: 24px;
          height: 24px;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cline x1='18' y1='6' x2='6' y2='18'%3E%3C/line%3E%3Cline x1='6' y1='6' x2='18' y2='18'%3E%3C/line%3E%3C/svg%3E");
          cursor: pointer;
        }
      }
      .pop-content {
        padding: 20px;
        .hg {
          display: flex;
          align-items: center;
          margin-bottom: 18px;
          .leftSpan {
            width: 80px;
            color: $text-main;
            font-size: 14px;
            flex-shrink: 0;
          }
          span:not(.leftSpan) {
            padding: 6px 12px;
            border-radius: 6px;
            font-size: 14px;
            margin-right: 8px;
            cursor: pointer;
            border: 1px solid $border-color;
            color: $text-secondary;
            &.active {
              background: linear-gradient(90deg, $primary-color, #ffd780);
              color: #482000;
              border: none;
            }
          }
          input {
            flex: 1;
            height: 36px;
            padding: 0 12px;
            border: 1px solid $border-color;
            border-radius: 6px;
            color: $text-main;
            font-size: 14px;
            box-sizing: border-box;
            &.popup-balance {
              background: #fff8e6;
              color: $primary-color !important;
              font-weight: 500 !important;
              text-align: right;
              border: none !important;
            }
            &:disabled {
              background: #fafafa;
              color: $text-secondary;
            }
          }
        }
        .button {
          display: block;
          width: 100%;
          height: 42px;
          line-height: 42px;
          background: linear-gradient(90deg, $primary-color, #ffd780);
          color: #482000;
          text-align: center;
          border-radius: 6px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s;
          margin-top: 8px;
          box-shadow: 0 2px 8px rgba(254, 203, 77, 0.2);

          &:hover {
            opacity: 0.95;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(254, 203, 77, 0.3);
          }
        }
      }
    }
  }
}
// 通用卡片样式
.card-style {
  background: $card-bg;
  border-radius: $card-radius;
  box-shadow: $card-shadow;
}
// 状态标签样式
.status {
  &:contains("审核通过"), &:contains("成功") {
    background: #e8f5e9;
    color: #4caf50;
  }
  &:contains("待审核"), &:contains("待结算") {
    background: #fff3e0;
    color: #ff9800;
  }
  &:contains("审核拒绝"), &:contains("失败"), &:contains("无效注单") {
    background: #ffebee;
    color: #f44336;
  }
  &:contains("未结算"), &:contains("待领取") {
    background: #e3f2fd;
    color: #2196f3;
  }
  &:contains("已领取"), &:contains("已结算") {
    background: #e0f7fa;
    color: #00bcd4;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/assets.vue